import { IMAGE_SIZE } from '@api/media/constants';
import { ULTIMATE_DESIGN_BACKGROUND_COLORS, WA_BLACK, WA_TRANSPARANT } from '@constants';
import * as utils from '@utils/form';

export const SCROLL_NEWS_ITEM_FIELDS = {
  SLIDE_SUBTITLE: {
    name: 'subheadline',
    label: 'Subheadline:',
    placeholder: 'Enter a subtitle for the item',
    rules: [{ required: true, message: 'Subheadline is required' }],
  },
  SLIDE_TITLE: {
    name: 'headline',
    label: 'Headline:',
    placeholder: 'Enter a title for the item',
    rules: [{ required: true, message: 'Headline is required' }],
  },
  SLIDE_STRAPLINE: {
    name: 'strapline',
    label: 'Strapline:',
    placeholder: 'Enter a strapline for the item',
    rules: [{ required: true, message: 'Strapline is required' }],
  },
  SLIDE_IMAGE: {
    name: 'image',
    label: 'Image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['2000x714'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  SLIDE_READ_MORE_LINK: {
    name: 'readMoreLink',
    label: 'Read more link for item:',
    placeholder: 'Enter a link for the item',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'Link is required' },
    ],
  },
  SLIDE_READ_MORE_TEXT: {
    name: 'readMoreText',
    label: 'Read more text for item:',
    placeholder: 'Enter link text for the slide',
    rules: [{ required: true, message: 'Read more text is required' }],
  },
  SLIDE_DATE: {
    name: 'date',
    label: 'Date:',
    placeholder: 'Enter a date for the item',
    rules: [{ required: true, message: 'Date is required' }],
  },
};

export const SLIDES = {
  name: 'slides',
  rules: [{ min: 1, max: 6 }],
  serialize: (field, values) => {
    const value = values[field.name];
    return {
      slides: value?.map(({ article, ...data }) =>
        article
          ? {
              articleId: article.contentId || article.id,
              imageId: article.featureImageId,
              imageEdited: article.featureImageEdited,
              ...data,
            }
          : { ...data },
      ),
    };
  },
};

export const FORM_PANEL = {
  SLIDES,
  TITLE: {
    name: 'title',
    label: 'Module title:',
    placeholder: 'Enter a title for the panel',
    rules: [{ required: true, message: 'Title is required' }],
  },
  MORE_NEWS_LINK: {
    name: 'moreNewsLink',
    label: 'Read more link:',
    placeholder: 'Enter a link',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'Link is required' },
    ],
  },
  MORE_NEWS_TEXT: {
    name: 'moreNewsText',
    label: 'Read more text:',
    placeholder: 'Read more text',
    rules: [{ required: true, message: 'Read more text is required' }],
  },
  BACKGROUND_COLOUR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: ULTIMATE_DESIGN_BACKGROUND_COLORS,
    rules: [{ required: true, message: 'News panel background colour is required' }],
  },
};

export const SCROLL_NEWS_PANEL_INITS = {
  [FORM_PANEL.TITLE.name]: '',
  slides: [],
};
